let baseUri
if (process.env.NODE_ENV === 'development') {
    baseUri = 'https://dev.328ym.com/athlete'
} else {
    baseUri = 'https://hwy.328ym.com/athlete'
}
export const baseUrl = baseUri